<template>
  <v-container>
    <v-row wrap>
      <v-col>
        <v-card
          v-if="$store.getters.userDetails.role.toLowerCase() != 'user'"
          style="padding: 10px"
          elevation="1"
        >
          <v-toolbar style="box-shadow: none; padding: 5px">
            <v-row wrap>
              <v-col class="col-12" sm="12" md="12" style="padding: 5px;">
                <v-row wrap>
                  <v-col class="col-7" sm="7" md="7" style="padding: 0px 5px; text-align: center">
                    <v-text-field
                      v-model="search"
                      @input="searchContents"
                      prepend-icon="search"
                      label="Search"
                      single-line
                    ></v-text-field>
                  </v-col>

                  <v-col class="col-4" sm="4" md="4" style="padding: 0px 10px; text-align: center;">
                    <v-select
                      :items="sortByRole"
                      v-model="sortingMemberByRole"
                      @input="membersSorting"
                      style="font-size: 12px;"
                      item-text="name"
                      item-value="id"
                      label="Role"
                    ></v-select>
                  </v-col>

                  <v-col
                    class="col-1"
                    sm="1"
                    md="1"
                    style="text-align: center; padding: 0px 5px; margin-top: -5px"
                  >
                    <v-menu
                      :close-on-content-click="false"
                      :nudge-bottom="14"
                      offset-y
                      class="elelvation-1"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" icon text>
                          <v-icon medium class="black--text">more_vert</v-icon>
                        </v-btn>
                      </template>

                      <v-list class="pa-0">
                        <v-list-item v-if="showMemberDetails()" to="/bulkimport">
                          <v-list-item-avatar>
                            <v-icon medium dark color="primary">import_export</v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            Batch Import
                          </v-list-item-content>
                        </v-list-item>

                        <v-divider></v-divider>

                        <v-list-item @click="exportInCSV" style="cursor: pointer">
                          <v-list-item-avatar>
                            <v-icon medium dark color="primary">get_app</v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            Export
                          </v-list-item-content>
                        </v-list-item>

                        <v-divider></v-divider>

                        <v-list-item @click="selectAll" v-if="showMemberDetails()">
                          <v-list-item-avatar>
                            <v-icon medium dark color="primary">check_box</v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            Select all
                          </v-list-item-content>
                        </v-list-item>

                        <v-divider></v-divider>

                        <v-list-group
                          v-for="item in items"
                          :key="item.title"
                          v-model="item.active"
                          v-if="showMemberDetails()"
                          style="padding: 5px 0px;"
                        >
                          <template v-slot:activator>
                            <v-list-item style="padding: 0px 9px">
                              <v-list-item-action>
                                <v-icon medium dark color="primary">{{ item.action }}</v-icon>
                              </v-list-item-action>
                              <v-list-item-content>
                                {{ item.title }}
                              </v-list-item-content>
                            </v-list-item>
                          </template>

                          <v-list-item
                            v-for="subItem in item.items"
                            :key="subItem.title"
                            @click="subItem.onClick(this)"
                            style="padding-left: 35px"
                          >
                            <v-list-item-action>
                              <v-icon>{{ subItem.icon }}</v-icon>
                            </v-list-item-action>
                            <v-list-item-content style="font-size: 14px"
                              >{{ subItem.title }}
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-group>
                        <!-- </v-list> -->
                      </v-list>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-toolbar>
        </v-card>
      </v-col>
    </v-row>

    <v-row wrap>
      <v-col>
        <!-- <div v-if="" style="border-radius: 2px; box-shadow: none; padding: 10px"> -->
        <div v-if="membersContents.length > 0">
          <DisplayCard
            v-if="renderComponent"
            :renderData="membersContents"
            @deleteData="deleteItem"
            @editData="editItem"
            @selectDataIds="BulkDeleteIds"
            :selectAll="selectAllData"
          ></DisplayCard>
        </div>

        <div v-else align="center">
          <v-nodata
            :loading="loading.membersOption"
            :networkError="networkError.membersOption"
            @retryMethod="updateTagAndLocation"
            title=""
            msg-details="You haven't added any members yet"
            icon="nomembers"
            content-bg="lighten-4"
          >
          </v-nodata>
        </div>
      </v-col>
    </v-row>

    <!-- Dialog -->
    <v-dialog
      v-model="dialog"
      :fullscreen="$mq == 'mobile' ? true : false"
      style="overflow-y: hidden; overflow-x: hidden;"
      persistent
      max-width="600px"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          slot="activator"
          v-on="on"
          v-if="showMemberDetails()"
          @click="openAddWindow"
          color="primary"
          dark
          fixed
          bottom
          right
          fab
        >
          <v-icon>add</v-icon>
        </v-btn>
      </template>

      <v-card elevation="2" style="border-radius: 3px;">
        <v-card-title class="primary">
          <h4 class="reg__heading">{{ formTitle }}</h4>
          <v-spacer></v-spacer>
          <v-btn v-if="$mq == 'mobile'" @click="dialog = false" icon fab small dark>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
          <v-flex ref="addMember" xs12 sm12 md12>
            <v-layout row wrap>
              <v-flex xs6 sm6 md6 class="reg__custom__flex">
                <v-text-field
                  ref="First"
                  v-model="editedItem.firstName"
                  :rules="rulesFirst"
                  label="First Name *"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm6 md6 class="reg__custom__flex">
                <v-text-field v-model="editedItem.lastName" label="Last Name"></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12 class="reg__custom__flex">
                <v-text-field
                  ref="Email"
                  v-model="editedItem.email"
                  :rules="rulesEmail"
                  label="Email *"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm6 md6 class="reg__custom__flex">
                <v-text-field
                  v-model="editedItem.phone"
                  label="Phone Number"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm6 md6 class="reg__custom__flex">
                <v-select
                  v-model="editedItem.role"
                  :items="roleTypeCal"
                  :disabled="allowRoleSelect"
                  item-text="text"
                  item-value="value"
                  label="Select User Role"
                >
                </v-select>
              </v-flex>

              <v-flex xs12 sm12 md12 class="reg__custom__flex">
                <v-text-field v-model="editedItem.code" label="Employee Code"></v-text-field>
              </v-flex>

              <v-flex v-if="formTitle == 'New'" xs12 sm12 md12 class="reg__custom__flex">
                <v-switch v-model="passwordShow" color="primary" label="Set Password"></v-switch>
              </v-flex>

              <v-flex v-if="passwordShow" xs12 sm12 md12 class="reg__custom__flex">
                <v-text-field
                  ref="passwordRules"
                  v-if="formTitle == 'New'"
                  v-model="editedItem.password"
                  :rules="passwordRules"
                  label="Password"
                  type="password"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md12 class="reg__custom__flex">
                <v-select
                  v-model="editedItem.supervisor"
                  :items="supervisorsCal(false)"
                  item-text="displayName"
                  item-value="id"
                  label="Supervisor *"
                  required
                ></v-select>
              </v-flex>

              <v-flex xs12 sm12 md12 class="reg__custom__flex">
                <v-select
                  ref="Location"
                  v-bind:items="locationsCal"
                  v-model="editedItem.allowedLocations"
                  item-text="name"
                  item-value="id"
                  label="Locations *"
                  multiple
                  chips
                  required
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0">
                      <span>{{ item.name }}</span>
                    </v-chip>
                    <span v-if="index === 1" class="grey--text caption"
                      >(+{{ editedItem.allowedLocations.length - 1 }} others)</span
                    >
                  </template>
                </v-select>
              </v-flex>

              <v-flex xs12 sm6 md6 class="reg__custom__flex">
                <v-autocomplete
                  v-bind:items="groupsCal"
                  v-model="editedItem.groupId"
                  item-text="name"
                  item-value="id"
                  label="Groups *"
                  multiple
                  chips
                  required
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0">
                      <span>{{ item.name }}</span>
                    </v-chip>
                    <span v-if="index === 1" class="grey--text caption"
                      >(+{{ editedItem.groupId.length - 1 }} others)</span
                    >
                  </template>
                </v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 md6 class="reg__custom__flex">
                <v-autocomplete
                 v-bind:items="shiftsCal"
                  v-model="editedItem.allowedShifts"
                  item-text="name"
                  item-value="id"
                  label="Shift"
                  multiple
                  chips
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0">
                      <span>{{ item.name }}</span>
                    </v-chip>
                    <span v-if="index === 1" class="grey--text caption"
                      >(+{{ editedItem.allowedShifts.length - 1 }} others)</span
                    >
                  </template>
                </v-autocomplete>
              </v-flex>

              <v-flex v-if="forms.length > 0" xs12 sm6 md6 class="reg__custom__flex">
                <v-autocomplete
                  v-model="editedItem.allowedForms"
                  v-bind:items="forms"
                  item-text="name"
                  item-value="id"
                  label="Forms"
                  multiple
                  chips
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0">
                      <span>{{ item.name }}</span>
                    </v-chip>
                    <span v-if="index === 1" class="grey--text caption"
                      >(+{{ editedItem.allowedForms.length - 1 }} others)</span
                    >
                  </template>
                </v-autocomplete>
              </v-flex>

              <v-flex v-if="tags.length > 0" xs12 sm6 md6 class="reg__custom__flex">
                <v-autocomplete
                  v-model="editedItem.tags"
                  v-bind:items="tags"
                  item-text="name"
                  item-value="id"
                  label="Tags"
                  multiple
                  chips
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0">
                      <span>{{ item.name }}</span>
                    </v-chip>
                    <span v-if="index === 1" class="grey--text caption"
                      >(+{{ editedItem.tags.length - 1 }} others)</span
                    >
                  </template>
                </v-autocomplete>
              </v-flex>

              <!-- weekOff -->
              <v-flex v-if="allowedWeeklyOffSets.length > 0" xs12 sm6 md6 class="reg__custom__flex">
                <v-autocomplete
                  v-model="editedItem.allowedWeeklyOffSets"
                  :items="allowedWeeklyOffSets"
                  item-text="name"
                  item-value="id"
                  label="WeekOff"
                  multiple
                  chips
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0">
                      <span>{{ item.name }}</span>
                    </v-chip>
                    <span v-if="index === 1" class="grey--text caption"
                      >(+{{ editedItem.allowedWeeklyOffSets.length - 1 }} others)</span
                    >
                  </template>
                </v-autocomplete>
              </v-flex>

              <!-- holiday -->
              <v-flex v-if="allowedHolidaySets.length > 0" xs12 sm6 md6 class="reg__custom__flex">
                <v-autocomplete
                  v-model="editedItem.allowedHolidaySets"
                  :items="allowedHolidaySets"
                  item-text="name"
                  item-value="id"
                  label="Holiday Set"
                  multiple
                  chips
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0">
                      <span>{{ item.name }}</span>
                    </v-chip>
                    <span v-if="index === 1" class="grey--text caption"
                      >(+{{ editedItem.allowedHolidaySets.length - 1 }} others)</span
                    >
                  </template>
                </v-autocomplete>
              </v-flex>

              <v-flex
                v-if="canSee('viewPermission', editedItem.role)"
                xs12
                sm12
                md12
                class="reg__custom__flex"
              >
                <v-autocomplete
                  v-model="editedItem.permissions"
                  v-bind:items="permissions"
                  item-text="displayName"
                  item-value="id"
                  label="Permissions"
                  multiple
                  chips
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0">
                      <span>{{ item.displayName }}</span>
                    </v-chip>
                    <span v-if="index === 1" class="grey--text caption"
                      >(+{{ editedItem.permissions.length - 1 }} others)</span
                    >
                  </template>
                </v-autocomplete>
              </v-flex>

              <v-flex xs12 sm12 md12 style="padding: 0px">
                <v-layout row wrap>
                  <v-flex xs10 sm10 md10>
                    <v-autocomplete
                      ref="Time"
                      :value="autoDetectTimeZone"
                      v-model="editedItem.tz.name"
                      :items="timeZones"
                      :rules="rulesTime"
                      prepend-icon=" "
                      label="Select Timezone *"
                      class="gps-field"
                      required
                      chips
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs2 sm2 md2 style="text-align: center; margin-top: 7px">
                    <v-btn slot="activator" @click.native="autoDetectTimeZone" text fab>
                      <v-icon>my_location</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12 sm12 md12 class="reg__custom__flex">
                <v-list>
                  <v-list-group no-action style="background-color: #f5f5f5">
                    <template v-slot:activator>
                      <v-list-item-content
                        style="font-size: 15px; font-weight: 500;letter-spacing: 0.5px; color: #454545"
                      >
                        Security Settings
                      </v-list-item-content>
                    </template>

                    <v-list-item style="padding-left: 10px">
                      <v-list-item-content>
                        <v-flex xs12 sm12 md12 style="padding: 0px 25px">
                          <v-layout row>
                            <v-switch
                              v-model="editedItem.securitySettings.isGeoseal"
                              v-bind:label="'Geoseal'"
                              color="primary"
                            ></v-switch>

                            <v-tooltip v-model="showGeoseal" right>
                              <template v-slot:activator="{ on }">
                                <div style="padding-top: 14px;">
                                  <v-btn @click="showGeoseal = !showGeoseal" v-on="on" icon>
                                    <v-icon color="grey lighten-1">info</v-icon>
                                  </v-btn>
                                </div>
                              </template>
                              <span>Checks whether Attendance was marked inside premises </span>
                            </v-tooltip>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm12 md12 style="padding: 0px 25px">
                          <v-layout row>
                            <v-switch
                              v-bind:label="'Photoid'"
                              v-model="editedItem.securitySettings.isPhotoid"
                              color="primary"
                              light
                            ></v-switch>

                            <v-tooltip v-model="showPhotoId" right>
                              <template v-slot:activator="{ on }">
                                <div style="padding-top: 14px;">
                                  <v-btn @click="showPhotoId = !showPhotoId" v-on="on" icon>
                                    <v-icon color="grey lighten-1">info</v-icon>
                                  </v-btn>
                                </div>
                              </template>
                              <span>Takes a selfie during Attendance </span>
                            </v-tooltip>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm12 md12 style="padding: 0px 25px">
                          <v-layout row>
                            <v-switch
                              v-bind:label="'Wifissid'"
                              v-model="editedItem.securitySettings.isWifissid"
                              color="primary"
                              light
                            ></v-switch>

                            <v-tooltip v-model="showWifi" right>
                              <template v-slot:activator="{ on }">
                                <div style="padding-top: 14px;">
                                  <v-btn @click="showWifi = !showWifi" v-on="on" icon>
                                    <v-icon color="grey lighten-1">info</v-icon>
                                  </v-btn>
                                </div>
                              </template>
                              <span>Checks whether Attendance was marked using mapped WiFi </span>
                            </v-tooltip>
                          </v-layout>
                        </v-flex>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-group>
                </v-list>
              </v-flex>

              <v-flex xs12 sm12 md12 class="reg__custom__flex">
                <v-list>
                  <v-list-group no-action style="background-color: #f5f5f5">
                    <template v-slot:activator>
                      <v-list-item-content
                        style="font-size: 15px; font-weight: 500;letter-spacing: 0.5px; color: #454545"
                      >
                        Advanced
                      </v-list-item-content>
                    </template>

                    <v-list-item style="padding-left: 10px">
                      <v-list-item-content>
                        <v-flex xs12 sm12 md12 style="padding: 0px 25px">
                          <v-layout row>
                            <v-switch
                              v-bind:label="'Match Device'"
                              v-model="editedItem.securitySettings.matchDevice"
                              color="primary"
                              light
                            ></v-switch>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm12 md12 style="padding: 0px 25px">
                          <v-layout row>
                            <v-switch
                              v-model="editedItem.securitySettings.detectHotspot"
                              v-bind:label="'Covid Hotspot'"
                              color="primary"
                            ></v-switch>

                            <v-tooltip v-model="showHotspot" right>
                              <template v-slot:activator="{ on }">
                                <div style="padding-top: 14px;">
                                  <v-btn @click="showHotspot = !showHotspot" v-on="on" icon>
                                    <v-icon color="grey lighten-1">info</v-icon>
                                  </v-btn>
                                </div>
                              </template>
                              <span
                                >Alerts if attendance or field tracking was in a Covid hotspot
                                (India Only)</span
                              >
                            </v-tooltip>
                          </v-layout>
                        </v-flex>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-group>
                </v-list>
              </v-flex>

              <v-flex xs12 sm12 md12 class="reg__custom__flex">
                <v-list>
                  <v-list-group no-action style="background-color: #f5f5f5">
                    <template v-slot:activator>
                      <v-list-item-content
                        style="font-size: 15px; font-weight: 500; letter-spacing: 0.5px; color: #454545"
                      >
                        Field Tracking
                      </v-list-item-content>
                    </template>

                    <v-list-item style="padding-left: 10px">
                      <v-list-item-content>
                        <v-flex xs12 sm12 md12 style="padding: 0px 25px">
                          <v-layout row>
                            <v-switch
                              v-bind:label="'Mark Location'"
                              v-model="editedItem.fieldTrackingSettings.enabled"
                              color="primary"
                              light
                            ></v-switch>

                            <v-tooltip v-model="showField" right>
                              <template v-slot:activator="{ on }">
                                <div style="padding-top: 14px;">
                                  <v-btn @click="showField = !showField" v-on="on" icon>
                                    <v-icon color="grey lighten-1">info</v-icon>
                                  </v-btn>
                                </div>
                              </template>
                              <span>Records GPS-based Information for Field Visits </span>
                            </v-tooltip>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12 style="padding: 0px 25px">
                          <v-layout row>
                            <v-switch
                              v-if="editedItem.fieldTrackingSettings.enabled == true"
                              v-bind:label="'Take Picture'"
                              v-model="editedItem.fieldTrackingSettings.isPhotoid"
                              color="primary"
                              light
                            ></v-switch>

                            <v-tooltip
                              v-model="showFieldPhoto"
                              v-if="editedItem.fieldTrackingSettings.enabled == true"
                              right
                            >
                              <template v-slot:activator="{ on }">
                                <div style="padding-top: 14px;">
                                  <v-btn @click="showFieldPhoto = !showFieldPhoto" v-on="on" icon>
                                    <v-icon color="grey lighten-1">info</v-icon>
                                  </v-btn>
                                </div>
                              </template>
                              <span>Records Photo for Field Visits </span>
                            </v-tooltip>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12 style="padding: 0px 25px">
                          <v-layout row>
                            <v-select
                              v-if="editedItem.fieldTrackingSettings.enabled == true"
                              v-model="editedItem.fieldTrackingSettings.formId"
                              :items="forms"
                              item-text="name"
                              item-value="id"
                              label="Submit Form"
                              multiple
                              chips
                            >
                              <template v-slot:selection="{ item, index }">
                                <v-chip v-if="index === 0">
                                  <span>{{ item.name }}</span>
                                </v-chip>
                                <span v-if="index === 1" class="grey--text caption"
                                  >(+{{
                                    editedItem.fieldTrackingSettings.formId.length - 1
                                  }}
                                  others)</span
                                >
                              </template>
                            </v-select>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm12 md12 style="padding: 0px 25px">
                          <v-layout row>
                            <v-switch
                              v-bind:label="'Realtime Tracking'"
                              v-model="editedItem.realtimeFieldTrackingSettings.enabled"
                              color="primary"
                              light
                            ></v-switch>

                            <v-tooltip v-model="showRealField" right>
                              <template v-slot:activator="{ on }">
                                <div style="padding-top: 14px;">
                                  <v-btn @click="showRealField = !showRealField" v-on="on" icon>
                                    <v-icon color="grey lighten-1">info</v-icon>
                                  </v-btn>
                                </div>
                              </template>
                              <span>Tracks Live Route Information for Trips </span>
                            </v-tooltip>
                          </v-layout>
                        </v-flex>

                        <v-flex
                          v-if="editedItem.realtimeFieldTrackingSettings.enabled"
                          xs12
                          sm12
                          md12
                          style="padding: 0px 25px"
                        >
                          <v-layout row>
                            <v-switch
                              v-bind:label="'Auto Start With Check In'"
                              v-model="editedItem.realtimeFieldTrackingSettings.autoStart"
                              color="primary"
                              light
                            ></v-switch>
                          </v-layout>
                        </v-flex>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-group>
                </v-list>
              </v-flex>

              <!-- <v-flex xs12 sm12 md12 class="reg__custom__flex">
                <v-list>
                  <v-list-group no-action style="background-color: #f5f5f5">
                    <template v-slot:activator>
                      <v-list-item-content
                        style="font-size: 15px; font-weight: 500; letter-spacing: 0.5px; color: #454545"
                      >
                        Activity Tracking
                      </v-list-item-content>
                    </template>

                    <v-list-item style="padding-left: 10px">
                      <v-list-item-content>
                        <v-flex xs12 sm12 md12 style="padding: 0px 25px">
                          <v-layout row>
                            <v-switch
                              v-bind:label="'Enable Activity Tracking'"
                              v-model="editedItem.activityTrackings.enabled"
                              color="primary"
                              light
                            ></v-switch>

                            <v-tooltip v-model="showField" right>
                              <template v-slot:activator="{ on }">
                                <div style="padding-top: 14px;">
                                  <v-btn @click="showField = !showField" v-on="on" icon>
                                    <v-icon color="grey lighten-1">info</v-icon>
                                  </v-btn>
                                </div>
                              </template>
                              <span>Track the activities of the user</span>
                            </v-tooltip>
                          </v-layout>
                        </v-flex>

                        <v-flex
                          v-if="editedItem.activityTrackings.enabled"
                          xs12
                          sm12
                          md12
                          style="padding: 0px 25px"
                        >
                          <v-layout row>
                            <v-text-field
                              v-model="editedItem.activityTrackings.trackingDeviceId"
                              label="Activity Tracking Device Id"
                            ></v-text-field>
                          </v-layout>
                        </v-flex>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-group>
                </v-list>
              </v-flex> -->
            </v-layout>
          </v-flex>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-btn v-if="formTitle != 'New'" @click.native="qrDialog = true" color="primary" text
            ><v-icon>mdi-qrcode</v-icon>QR</v-btn
          >

          <v-btn
            v-if="
              formTitle != 'New' &&
                ($store.getters.userDetails.role == 'SuperAdmin' ||
                  ($store.getters.userDetails.role == 'Admin' && canSee('modifyUser')))
            "
            @click="openResetWindow"
            color="primary"
            text
            style="text-align: left !important"
            >Set<br />Password</v-btn
          >

          <v-spacer></v-spacer>

          <v-btn
            v-if="
              formTitle != 'New' &&
                ($store.getters.userDetails.role == 'SuperAdmin' ||
                  ($store.getters.userDetails.role == 'Admin' && canSee('modifyUser'))) &&
                matchDevice == true
            "
            @click="resetDevice(editedItem)"
            color="primary"
            text
            style="text-align: left !important"
            >Reset <br />Device
          </v-btn>

          <v-btn
            @click.native="close"
            v-if="$mq != 'mobile'"
            color="blue darken-1"
            text
            style="font-size: 13px; letter-spacing: 1px; padding-top: 2px;"
            >Cancel</v-btn
          >
          <v-btn
            v-if="formTitle == 'New' && canSee('modifyUser')"
            :disabled="afterUpdate"
            @click.native="save"
            color="primary"
            >Save</v-btn
          >
          <v-btn
            v-else-if="canSee('modifyUser', false, { recepientRole: editedItem.role })"
            :disabled="afterUpdate"
            @click.native="save"
            color="primary"
            >Update</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- AllowedLocation -->
    <v-dialog v-model="allowedLocationDialog" max-width="400">
      <v-card elevation="1">
        <v-card-title class="primary">
          <h3 style="margin-top: 0px" class="reg__heading">Bulk Edit Locations</h3>
        </v-card-title>
        <v-card-text style="padding-bottom: 0px">
          <!-- <v-container grid-list-md> -->
          <v-row wrap>
            <v-col xs12 sm12>
              <v-autocomplete
                v-bind:items="locations"
                v-model="bulkSelectedAllowedLocation"
                item-text="name"
                item-value="id"
                label="Locations"
                multiple
                chips
              ></v-autocomplete>
            </v-col>
          </v-row>
          <!-- </v-container> -->
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="allowedLocationDialog = false" color="primary" text>Cancel</v-btn>
          <v-btn
            :disabled="afterUpdate"
            :loading="afterUpdate"
            @click.native="bulkMembersOperation('changeAllowedLocation')"
            color="primary"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Bulk Add Dialog -->
    <!-- not needed just in case (bulk member addition) -->
    <v-dialog v-model="bulkAddDialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Bulk Member Add</v-card-title>
        <v-card-text>
          <!-- <v-container grid-list-md> -->
          <v-row wrap>
            <v-col xs12 sm12>
              <v-select
                v-model="editedItem.tz.name"
                :items="timeZones"
                label="Select Timezone"
                prepend-icon="access_time"
                required
              ></v-select>
              <v-text-field
                @click="pickFile"
                v-model="csvName"
                label="Select Csv File"
                prepend-icon="attach_file"
              ></v-text-field>
              <input
                id="csv_file"
                ref="csv"
                @change="loadCSV($event)"
                type="file"
                style="display: none"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                name="csv_file"
                class="form-control"
              />
              <!-- <v-btn color="green" class="white--text" @click="login" flat>Bulk Add</v-btn> -->
            </v-col>
          </v-row>
          <!-- </v-container> -->
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="bulkAddDialog = false" color="primary" text>Cancel</v-btn>
          <v-btn @click.native="bulkMemberAdd" color="primary">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Supervisor -->
    <v-dialog v-model="bulkSupervisorDialog" max-width="400">
      <v-card elevation="1">
        <v-card-title class="primary">
          <h3 style="margin-top: 0px" class="reg__heading">
            Bulk Edit Supervisor
          </h3>
        </v-card-title>
        <v-card-text style="padding-bottom: 0px">
          <!-- <v-container grid-list-md> -->
          <v-row wrap>
            <v-col xs12 sm12>
              <v-select
                :items="supervisorsCal(true)"
                v-model="bulkSelectedAllowedSupervisor"
                item-text="firstName"
                item-value="id"
                label="Supervisor"
                required
              ></v-select>
            </v-col>
          </v-row>
          <!-- </v-container> -->
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="bulkSupervisorDialog = false" color="primary" text>Cancel</v-btn>
          <v-btn
            :disabled="afterUpdate"
            :loading="afterUpdate"
            @click.native="bulkMembersOperation('changeSupervisor')"
            color="primary"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Groups -->
    <v-dialog v-model="bulkGroupDialog" max-width="400">
      <v-card elevation="1">
        <v-card-title class="primary">
          <h3 style="margin-top: 0px" class="reg__heading">Bulk Edit Groups</h3>
        </v-card-title>
        <v-card-text style="padding-bottom: 0px">
          <!-- <v-container grid-list-md> -->
          <v-row wrap>
            <v-col xs12 sm12>
              <v-autocomplete
                v-bind:items="groups"
                v-model="bulkSelectedAllowedGroup"
                item-text="name"
                item-value="id"
                label="Groups"
                multiple
                chips
                required
              ></v-autocomplete>
            </v-col>
          </v-row>
          <!-- </v-container> -->
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="bulkGroupDialog = false" color="primary" text>Cancel</v-btn>
          <v-btn
            :disabled="afterUpdate"
            :loading="afterUpdate"
            @click.native="bulkMembersOperation('changeGroup')"
            color="primary"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Shift -->
    <v-dialog v-model="bulkShiftDialog" max-width="400">
      <v-card elevation="1">
        <v-card-title class="primary">
          <h3 style="margin-top: 0px" class="reg__heading">Bulk Edit Shifts</h3>
        </v-card-title>
        <v-card-text style="padding-bottom: 0px">
          <!-- <v-container grid-list-md> -->
          <v-row wrap>
            <v-col xs12 sm12>
              <v-autocomplete
                v-bind:items="shiftsCal"
                v-model="bulkSelectedAllowedShift"
                required
                item-text="name"
                item-value="id"
                label="Shift"
                multiple
                chips
              ></v-autocomplete>
            </v-col>
          </v-row>
          <!-- </v-container> -->
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="bulkShiftDialog = false" color="primary" text>Cancel</v-btn>
          <v-btn
            :disabled="afterUpdate"
            :loading="afterUpdate"
            @click.native="bulkMembersOperation('changeShifts')"
            color="primary"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Forms -->
    <v-dialog v-model="bulkFormDialog" max-width="400">
      <v-card elevation="1">
        <v-card-title class="primary">
          <h3 class="reg__heading" style="margin-top: 0px">Bulk Edit AllowedForms</h3>
        </v-card-title>
        <v-card-text style="padding-bottom: 0px">
          <!-- <v-container grid-list-md> -->
          <v-row wrap>
            <v-col xs12 sm12 style="text-align: center">
              <v-autocomplete
                v-bind:items="forms"
                v-model="bulkSelectedAllowedForm"
                item-text="name"
                item-value="id"
                label="Forms"
                multiple
                chips
              ></v-autocomplete>
            </v-col>
          </v-row>
          <!-- </v-container> -->
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="bulkFormDialog = false" color="primary" text>Cancel</v-btn>
          <v-btn
            :disabled="afterUpdate"
            :loading="afterUpdate"
            @click.native="bulkMembersOperation('changeForms')"
            color="primary"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--Security Settings -->
    <v-dialog v-model="bulkSettingDialog" max-width="400">
      <v-card elevation="1">
        <v-card-title class="primary">
          <h3 style="margin-top: 0px" class="reg__heading">Bulk Settings</h3>
        </v-card-title>
        <v-card-text style="padding-bottom: 0px">
          <!-- <v-container grid-list-md> -->
          <v-row wrap>
            <v-col xs12 sm12 style="text-align:center">
              <h4>Security Settings</h4>

              <v-switch
                v-model="bulkSelectedSecuritySettings.isGeoseal"
                v-bind:label="'Geoseal'"
                color="primary"
              ></v-switch>
              <v-switch
                v-bind:label="'Photoid'"
                v-model="bulkSelectedSecuritySettings.isPhotoid"
                color="primary"
                light
              ></v-switch>
              <v-switch
                v-bind:label="'Wifissid'"
                v-model="bulkSelectedSecuritySettings.isWifissid"
                color="primary"
                light
              ></v-switch>

              <v-layout row wrap style="padding-top: 2%;">
                <v-flex xs12 sm12 md12 style="margin-bottom: 7px">
                  <v-expansion-panels>
                    <v-expansion-panel v-for="(item, i) in 1" :key="i">
                      <v-expansion-panel-header expand-icon="mdi-menu-down">
                        <v-flex xs12 text-xs-right class="customFont">Advanced</v-flex>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-layout row wrap>
                          <v-switch
                            v-model="bulkSelectedSecuritySettings.matchDevice"
                            v-bind:label="'Match Device'"
                            color="primary"
                            light
                          ></v-switch>
                        </v-layout>

                        <v-layout row wrap>
                          <v-switch
                            v-model="bulkSelectedSecuritySettings.detectHotspot"
                            v-bind:label="'Covid Hotspot'"
                            color="primary"
                          ></v-switch>
                        </v-layout>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-flex>
              </v-layout>
            </v-col>
          </v-row>
          <!-- </v-container> -->
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="bulkSettingDialog = false" color="primary" text>Cancel</v-btn>
          <v-btn
            :disabled="afterUpdate"
            :loading="afterUpdate"
            @click.native="bulkMembersOperation('changeSecurity')"
            color="primary"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- FieldTarcking Settings -->
    <v-dialog v-model="bulkFieldTrackingSettingDialog" max-width="400">
      <v-card elevation="1">
        <v-card-title class="primary">
          <h3 style="margin-top: 0px" class="reg__heading">Bulk Settings</h3>
        </v-card-title>
        <v-card-text style="padding-bottom: 0px">
          <v-container grid-list-md>
            <v-row wrap>
              <v-col xs12 sm12>
                <h4>FieldTracking Settings</h4>
                <v-switch
                  v-bind:label="'Fieldtracking'"
                  v-model="bulkSelectedFieldTrackingSettings.enabled"
                  color="primary"
                  light
                ></v-switch>
                <v-switch
                  v-if="bulkSelectedFieldTrackingSettings.enabled == true"
                  v-bind:label="'Fieldtracking Photoid'"
                  v-model="bulkSelectedFieldTrackingSettings.isPhotoid"
                  color="primary"
                  light
                ></v-switch>

                <v-select
                  v-if="bulkSelectedFieldTrackingSettings.enabled == true"
                  v-model="bulkSelectedFieldTrackingSettings.formId"
                  :items="[...forms, { name: 'None', id: '' }]"
                  item-text="name"
                  item-value="id"
                  label="Fieldtracking Form"
                  required
                >
                </v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="bulkFieldTrackingSettingDialog = false" color="primary" text
            >Cancel</v-btn
          >
          <v-btn
            :disabled="afterUpdate"
            :loading="afterUpdate"
            @click.native="bulkMembersOperation('changeFieldTrackingSettings')"
            color="primary"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- RealtimefieldTracking Settings -->
    <v-dialog v-model="bulkRealTimeFieldTrackingDialog" max-width="400">
      <v-card elevation="1">
        <v-card-title class="primary">
          <h3 style="margin-top: 0px" class="reg__heading">Bulk Settings</h3>
        </v-card-title>
        <v-card-text style="padding-bottom: 0px">
          <v-container grid-list-md>
            <v-row wrap>
              <v-col xs12 sm12>
                <h4>RealTimeFieldTracking Settings</h4>
                <v-switch
                  v-bind:label="'Realtime Fieldtracking'"
                  v-model="bulkSelectedRealTimeFieldTracking.enabled"
                  color="primary"
                  light
                ></v-switch>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="bulkRealTimeFieldTrackingDialog = false" color="primary" text
            >Cancel</v-btn
          >
          <v-btn
            :disabled="afterUpdate"
            :loading="afterUpdate"
            @click.native="bulkMembersOperation('changeRealtimeFieldTrackingSettings')"
            color="primary"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- qr code -->
    <v-dialog v-model="qrDialog" max-width="400">
      <v-card v-if="editedItem.id">
        <v-card-title class="headline">QR Code</v-card-title>
        <v-card-text text-align="center">
          <qr-code ref="qr" :text="editedItem.id" :size="250"></qr-code>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="qrDialog = false" color="primary" flat>Cancel</v-btn>
          <v-btn @click.native="downloadQR" color="primary" flat>Download</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- reset password window -->
    <v-dialog v-model="resetWindow" persistent max-width="400">
      <v-card v-if="editedItem.id" elevation="1">
        <v-card-title class="primary">
          <h3 class="reg__heading" style="margin: 0px">Reset Password</h3>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-flex xs12 sm12 md12 class="reg__custom__flex">
            <v-text-field v-model="newPassword" label="New Password"></v-text-field>
          </v-flex>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="resetWindow = false" text color="primary">Cancel</v-btn>
          <v-btn
            @click="resetPassword"
            :disabled="afterUpdate"
            :loading="afterUpdate"
            color="primary"
            >Reset</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- loader -->
    <v-dialog v-model="loader" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- overlay -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import blob from "blob";
import firebase from "firebase";
import moment from "moment-timezone";
import canSee from "@/utilities/canSee";
// import errorHandler from '@/utilities/errorHandler';
import { EventBus } from "@/utilities/event-bus.js";
import { isMobile } from "mobile-device-detect";
import VNodata from "@/components/Unavailable/nodata.vue";
import DisplayCard from "@/views/card.vue";

import { disableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";
import fb from "@/utilities/firebase";
import Papa from "papaparse";

export default {
  components: {
    VNodata,
    DisplayCard
  },
  data: () => ({
    matchDevice: false,
    loader: false,
    overlay: false,
    newPassword: "",
    resetWindow: false,
    showGeoseal: false,
    showHuddle: false,
    showHotspot: false,
    showPhotoId: false,
    showWifi: false,
    showField: false,
    showFieldPhoto: false,
    showRealField: false,
    passwordShow: false,
    qrDialog: false,
    membersContents: [],
    selectedMembersId: [],
    renderComponent: true,
    selectAllData: false,
    sortByRole: [
      { id: "superadmin", name: "Super Admin" },
      { id: "admin", name: "Admin" },
      { id: "user", name: "User" },
      { id: "showall", name: "Show All" }
    ],
    sortingMemberByRole: "",
    membersSortByAlphabeticOrder: false,
    rulesFirst: [v => /^[A-Za-z0-9\-][a-zA-Z0-9 ]+[a-zA-Z0-9]*$/.test(v) || "Enter a valid Name"],
    rulesEmail: [
      v => !!v || "E-mail is required",
      v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w+)+$/.test(v.trim()) || "E-mail must be valid"
    ],
    rulesTime: [v => !!v || "TimeZone must be defined"],
    passwordRules: [v => /^[A-Za-z0-9\d\S\-]*$/.test(v) || "Password must be valid"],
    loading: {
      membersOption: true
    },
    networkError: {
      membersOption: false
    },
    selectedTags: {},
    dialog: false,
    allMembers: [],
    chipsTag: [],
    afterUpdate: false,
    // bulkmodes Dialogs
    allowedLocationDialog: false,
    bulkSupervisorDialog: false,
    bulkGroupDialog: false,
    unsub: () => {},
    bulkShiftDialog: false,
    bulkFormDialog: false,
    bulkSettingDialog: false,
    bulkFieldTrackingSettingDialog: false,
    bulkRealTimeFieldTrackingDialog: false,
    bulkAddDialog: false,
    csvName: "",
    parse_header: [],
    setLoading: true,
    companyData: [],
    tags: [],
    permissions: [],

    parse_csv: [],
    sortOrders: {},
    sortKey: "",
    search: "",
    companyId: "",
    roleType: [
      { text: "Super Admin", value: "SuperAdmin" },
      { text: "Admin", value: "Admin" },
      { text: "User", value: "User" }
    ],

    bulkSelectedAllowedLocation: [],
    bulkSelectedAllowedShift: [],
    bulkSelectedAllowedGroup: [],
    bulkSelectedAllowedSupervisor: [],
    bulkSelectedAllowedForm: [],
    bulkSelectedSecuritySettings: {
      isGeoseal: false,
      isPhotoid: false,
      isWifissid: false,
      matchDevice: false,
      isHuddle: false,
      detectHotspot: false
    },
    bulkSelectedFieldTrackingSettings: {
      enabled: false,
      isPhotoid: false,
      formId: "",
      isRealtime: false
    },
    bulkSelectedRealTimeFieldTracking: {
      enabled: false
    },

    selected: [],
    shifts: [],
    forms: [],

    members: [],
    supervisors: [],
    bulkdeleteDisabled: false,
    editedIndex: -1,
    allowedWeeklyOffSets: [],
    allowedHolidaySets: [],
    groups: [],
    editedItem: {
      groupId: [],
      companyId: "",
      email: "",
      firstName: "",
      supervisor: "",
      deviceFingerprint: "",
      securitySettings: {
        isGeoseal: false,
        isPhotoid: false,
        isWifissid: false,
        matchDevice: false,
        detectHotspot: false,
        isHuddle: false
      },
      fieldTrackingSettings: {
        enabled: false,
        isPhotoid: false,
        formId: [],
        isRealtime: false
      },
      realtimeFieldTrackingSettings: {
        enabled: false,
        autoStart: false
      },
      activityTrackings: {
        enabled: false,
        trackingDeviceId: ""
      },
      tz: {
        name: "",
        offset: ""
      },
      lastName: "",
      password: "",
      phone: 91,
      role: "Admin",
      allowedWeeklyOffSets: [],
      allowedHolidaySets: [],
      timeZones: [],
      allowedLocations: [],
      allowedShifts: [],
      allowedForms: [],
      tags: [],
      permissions: []
    },
    defaultItem: {
      groupId: [],
      companyId: "",
      email: "",
      firstName: "",
      supervisor: "",
      deviceFingerprint: "",
      securitySettings: {
        isGeoseal: false,
        isPhotoid: false,
        isWifissid: false,
        matchDevice: false,
        detectHotspot: false,
        isHuddle: false
      },
      fieldTrackingSettings: {
        enabled: false,
        isPhotoid: false,
        formId: []
      },
      realtimeFieldTrackingSettings: { enabled: false, autoStart: false },
      activityTrackings: {
        enabled: false,
        trackingDeviceId: ""
      },
      tz: {
        name: "",
        offset: ""
      },
      lastName: "",
      password: "",
      phone: 91,
      role: "Admin",
      allowedLocations: [],
      allowedShifts: [],
      allowedForms: [],
      tags: [],
      permissions: [],
      timeZones: [],
      allowedWeeklyOffSets: [],
      allowedHolidaySets: []
    },
    allLocations: []
  }),
  computed: {
    searchContents() {
      const self = this;
      self.renderComponent = false;
      self.selectAllData = false;

      try {
        _.each(self.membersContents, f => {
          var re = new RegExp(self.search.toLowerCase(), "g");
          if (
            f.title.toLowerCase().match(re) ||
            f.email.toLowerCase().match(re) ||
            f.allowedFormName.toLowerCase().match(re) ||
            f.allowedShiftsName.toLowerCase().match(re) ||
            f.supervisorName.toLowerCase().match(re)
          ) {
            f.visible = true;
          } else if (self.search == "") {
            f.visible = true;
          } else {
            f.visible = false;
          }
        });
      } catch (e) {}

      self.$nextTick(() => {
        self.renderComponent = true;
      });
    },

    pagination: {
      get: function() {
        if (this.$store.getters.pagination) {
          return this.$store.getters.pagination[this.$router.currentRoute.name];
        }
      },
      set: function(val) {
        this.$store.commit("setPagination", {
          name: this.$router.currentRoute.name,
          pagination: val
        });
      }
    },

    allowRoleSelect() {
      // If in edit more
      if (this.editedIndex > -1) {
        if (this.editedItem.role == "SuperAdmin" && this.$store.state.userDetails.role == "Admin")
          return true;
      }

      // If in new mode
      return false;
    },

    items() {
      const self = this;
      return [
        {
          action: "folder",
          title: "Batch Operations",
          items: [
            {
              title: "Delete",
              onClick() {
                self.bulkDeleteMembers();
              },
              icon: "delete_sweep"
            },
            {
              title: "Reset Device",
              onClick() {
                self.batchResetDevice();
              },
              icon: "device_unknown"
            },
            {
              title: "Location",
              onClick() {
                self.allowedLocationDialog = true;
                self.bulkSelectedAllowedLocation = [];
              },
              icon: "place"
            },
            {
              title: "Supervisor",
              onClick() {
                self.bulkSupervisorDialog = true;
                self.bulkSelectedAllowedSupervisor = [];
              },
              icon: "find_in_page"
            },
            {
              title: "Groups",
              onClick() {
                self.bulkGroupDialog = true;
                self.bulkSelectedAllowedGroup = [];
              },
              icon: "group"
            },
            {
              title: "Shifts",
              onClick() {
                self.bulkShiftDialog = true;
                self.bulkSelectedAllowedShift = [];
              },
              icon: "filter_tilt_shift"
            },
            {
              title: "Forms",
              onClick() {
                self.bulkFormDialog = true;
                self.bulkSelectedAllowedForm = [];
              },
              icon: "assignment"
            },
            {
              title: "Security",
              onClick() {
                self.bulkSelectedSecuritySettings = {};
                self.bulkSettingDialog = true;
              },
              icon: "settings"
            },
            {
              title: "FieldTracking",
              onClick() {
                self.bulkSelectedFieldTrackingSettings = {};
                self.bulkFieldTrackingSettingDialog = true;
              },
              icon: "nature_people"
            },
            {
              title: "RealTimeFieldTracking",
              onClick() {
                self.bulkSelectedRealTimeFieldTracking = {};
                self.bulkRealTimeFieldTrackingDialog = true;
              },
              icon: "near_me"
            }
          ]
        }
      ];
    },

    roleTypeCal() {
      if (this.roleType.length > 0 && !this.editedItem.role) console.log(this.editedIndex);

      // if(this.editedIndex <= -1) {
      //   this.editedItem.role = "Admin"
      // }

      // this.editedItem.role = this.roleType[0].value;
      const roleType = [];

      if (this.$store.state.userDetails.role == "Admin") {
        _.each(this.roleType, r => {
          if (r.value == "SuperAdmin") {
            r.disabled = true;
          }

          return roleType.push(r);
        });
      } else if (this.$store.state.userDetails.role == "SuperAdmin") {
        _.each(this.roleType, r => {
          roleType.push(r);
        });
      } else {
        _.each(this.roleType, r => {
          if (r.value.toLowerCase() != "user") {
            r.disabled = true;
          }

          return roleType.push(r);
        });
      }
      return roleType;
    },

    locations() {
      const locations = this.$store.getters.locationDetails;

      if (this.editedIndex <= -1) {
        // this.editedItem.allowedLocations = [locations[0].id];
      }
      return locations;
    },

    locationsCal() {
      const locations = this.allLocations;

      if (!(locations.length > 0)) {
        return [];
      }

      if (this.editedIndex <= -1) {
        this.editedItem.allowedLocations = [locations[0].id];
      }

      // Disabling the locations that the current user cannot edit
      return _.map(locations, o => {
        if (!_.find(this.$store.getters.locationDetails, g => g.id == o.id)) {
          o.disabled = true;
        }
        return o;
      });
    },

    shiftsCal() {

  
      var self = this;
      if (self.shifts.length > 0) {
        if (self.editedIndex <= -1) {
          self.editedItem.allowedShifts = [self.shifts[0].id];
        }
      }
      return self.shifts;


    },

    groupsCal() {
      //x =  {name : "all" , id : "all"}

      const { groups } = this;
      if (!(groups.length > 0)) {
        return [];
      }

      if (this.editedIndex <= -1) {
        this.editedItem.groupId = [groups[0].id];
      }

      return _.map(groups, o => {
        if (!_.find(this.$store.getters.groups, g => g.id == o.id)) {
          o.disabled = true;
        }
        return o;
      });
    },
    formTitle() {
      return this.editedIndex === -1 ? "New" : "Edit";
    },
    timeZones() {
      return moment.tz.names();
    }
  },

  beforeDestroy() {
    this.unsub();
  },

  created() {
    this.getAllLocations();
    this.getShifts();
    this.getPermissions();
    this.getForms();
    this.getCompany();
    this.getTags();

    this.autoDetectTimeZone();

    this.editedItem.companyId = this.$store.state.userDetails.companyId;
    this.defaultItem.companyId = this.$store.state.userDetails.companyId;

    this.getHolidaySet();
    this.getWeeklyOffSet();
    this.getGroups();

    const self = this;

    self.unsub = self.$store.subscribe((mutation, state) => {
      if (
        mutation.type === "setSelectedTags" ||
        mutation.type === "setMode" ||
        mutation.type === "setGroup"
      ) {
        const opts = {
          tags: _.map(
            _.filter(state.selectedTags, t => t.type == "tag"),
            "id"
          ),
          locations: _.map(
            _.filter(state.selectedTags, t => t.type == "location"),
            "id"
          ),
          mode: state.mode,
          group: state.group
        };
        self.updateTagAndLocation(opts);
      }
    });
    self.updateTagAndLocation(this.$store.getters.getSelectedTagsAndLocations);
    this.generateSupervisors();

    if (isMobile) {
      document.addEventListener(
        "deviceready",
        () => {
          self.checkFTState();
        },
        false
      );
    }
  },

  methods: {
    resetDevice(itemObj) {
      this.$http
        .post(`${this.$store.state.endpoint}Accounts/${itemObj.id}/resetdevice`)
        .then(response => {
          // success callback
          this.$swal({
            type: "success",
            text: "Device restored"
          });
        })
        .catch(err => {
          this.$swal({
            type: "error",
            text: "Something went wrong"
          });
        });
    },

    async createExportPayload(data) {
      try {
        data = _.map(data, d => {
          var exportObj = {};

          exportObj.FirstName = d.firstName;
          exportObj.LastName = d.lastName;
          exportObj.EmployeeCode = d.code == undefined ? "" : d.code;
          exportObj.Email = d.email;
          exportObj.Password = ""; // so that he can reupload this data through bulk upload
          exportObj.PhoneNumber = d.phone;
          exportObj.Role = d.role;
          exportObj.Groups = d.inGroupName;
          exportObj.Supervisors = d.supervisorEmail;
          exportObj.Location = d.allowedLocationName;
          exportObj.Shift = d.allowedShiftsName;
          exportObj.Tags = d.tagsName;
          exportObj.Forms = d.allowedFormName;
          exportObj.WeeklyOffSet = _.join(d.allowedWeeklyOffName, ", ");
          exportObj.HolidaySet = _.join(d.allowedHolidayName, ", ");

          // permission settings
          exportObj.modifyLocation = "";
          exportObj.modifyUser = "";
          exportObj.modifyTimesheet = "";
          exportObj.modifyShifts = "";
          exportObj.modifyHolidays = "";
          exportObj.modifyWeeklyOffs = "";
          exportObj.modifyForms = "";
          exportObj.allowHuddle = "";

          if (d.role.toLowerCase() == "admin" && d.permissions.length > 0) {
            var permissions = d.permissions;

            for (var m in permissions) {
              switch (permissions[m]) {
                case 1:
                  exportObj.modifyLocation = "Yes";
                  break;
                case 2:
                  exportObj.modifyUser = "Yes";
                  break;
                case 3:
                  exportObj.modifyTimesheet = "Yes";
                  break;
                case 4:
                  exportObj.modifyShifts = "Yes";
                  break;
                case 5:
                  exportObj.modifyHolidays = "Yes";
                  break;
                case 6:
                  exportObj.modifyWeeklyOffs = "Yes";
                  break;
                case 7:
                  exportObj.modifyForms = "Yes";
                  break;
                case 8:
                  exportObj.allowHuddle = "Yes";
                  break;
              }
            }
          }

          //settings security
          exportObj.Geoseal = d.securitySettings.isGeoseal ? "True" : "False";
          exportObj.Photoid = d.securitySettings.isPhotoid ? "True" : "False";
          exportObj.Wifissid = d.securitySettings.isWifissid ? "True" : "False";
          exportObj.DeviceMatch = d.securitySettings.matchDevice ? "True" : "False";
          exportObj.CovidAlert = d.securitySettings.detectHotspot ? "True" : "False";

          // fieldtracking
          exportObj.FieldTracking = d.fieldTrackingSettings.enabled ? "True" : "False";
          exportObj.FieldTrackingPhotoId = "";
          exportObj.FieldTrackingAllowedForms = "";
          if (d.fieldTrackingSettings.enabled) {
            exportObj.FieldTrackingPhotoId = d.fieldTrackingSettings.isPhotoid ? "True" : "False";
            var allowedForms = [];
            if (d.fieldTrackingSettings.formId) {
              if (d.fieldTrackingSettings.formId.length > 0) {
                for (var f in d.fieldTrackingSettings.formId) {
                  allowedForms.push(this.getFormName(d.fieldTrackingSettings["formId"][f]));
                }
                allowedForms = _.remove(allowedForms, undefined);
                exportObj.FieldTrackingAllowedForms = _.join(allowedForms, ", ");
              }
            }
          }

          // realtime fieldtracking
          exportObj.RealTimeFieldTracking = d.realtimeFieldTrackingSettings.enabled
            ? "True"
            : "False";

          return exportObj;
        });

        return data;
      } catch (e) {
        console.log(e);
        return [];
      }
    },

    getFormName(value) {
      for (const o in this.forms) {
        if (this.forms[o].id == value) {
          return this.forms[o].name;
        }
      }
    },

    async exportInCSV() {
      this.loader = true;

      var data = [];
      data = await this.createExportPayload(this.members);
      var csv = Papa.unparse(data);

      this.loader = false; // when data is recieved

      if (this.$mq != "mobile") {
        try {
          var csvData = new Blob([csv], {
            type: "text/csv;charset=utf-8;"
          });

          var csvURL = null;
          if (navigator.msSaveBlob) {
            csvURL = navigator.msSaveBlob(csvData, "download.csv");
          } else {
            csvURL = window.URL.createObjectURL(csvData);
          }

          var tempLink = document.createElement("a");
          tempLink.href = csvURL;
          tempLink.setAttribute("download", "download.csv");
          tempLink.click();
        } catch (e) {
          console.log(e);
        }
      } else {
        window.resolveLocalFileSystemURL(cordova.file.cacheDirectory, function(dir) {
          console.log("dir", dir);
          dir.getFile(
            "export-members-" + new Date().getTime() + ".csv",
            {
              create: true
            },
            function(file) {
              console.log("file", file);

              var logOb = file;

              function writeLog(str) {
                if (!logOb) return;
                logOb.createWriter(
                  function(fileWriter) {
                    fileWriter.seek(fileWriter.length);
                    var blob = new Blob([str], {
                      type: "text/csv;charset=utf-8;"
                    });
                    fileWriter.write(blob);
                    window.plugins.socialsharing.share(null, null, logOb.nativeURL, null);
                  },
                  () => {
                    this.$swal({ type: "error", text: "Something went wrong" });
                  }
                );
              }

              writeLog(csv);
            }
          );
        });
      }
    },
    showMemberDetails() {
      const self = this;
      if (self.$store.state.userDetails.role.toLowerCase() == "superadmin") {
        return true;
      } else if (
        self.$store.state.userDetails.role.toLowerCase() == "admin" &&
        self.canSee("modifyUser")
      ) {
        return true;
      }
      return false;
    },

    membersSorting() {
      const self = this;
      self.renderComponent = false;
      // loading all datas before operation
      self.membersContents = self.members;

      if (self.sortingMemberByRole != "") {
        if (self.sortingMemberByRole == "showall") {
          self.membersContents;
        } else {
          self.membersContents = _.filter(self.membersContents, data => {
            return data.role.toLowerCase() == self.sortingMemberByRole;
          });
        }
      }

      self.selectAllData = false;
    },

    selectAll() {
      this.renderComponent = false;
      this.selectAllData = true;
      this.$nextTick(() => {
        this.renderComponent = true;
      });
    },

    downloadQR() {
      const a = document.createElement("a");
      a.href = this.$refs.qr.$el.lastChild.src;
      a.download = `${this.editedItem.firstName}_qr.png`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },

    console(item) {
      return item;
    },

    supervisorsCal(editMode) {
      const self = this;

      if (!(self.editedIndex <= -1)) {
        editMode = true;
      }

      if (this.$store.state.userDetails.role.toLowerCase() == "user") {
        //User has one supervsior inside its own document
        var member = _.find(self.members, m => {
          return this.$store.state.userDetails.id == m.id;
        });
        member.supervisorDetails.displayName = `${member.supervisorDetails.firstName} ${member.supervisorDetails.lastName}(${member.supervisorDetails.email})`;
        return [member.supervisorDetails];
      }

      function calc(self) {
        if (self.supervisors.length > 0 && !self.editedItem.supervisor) {
          if (self.editedIndex <= -1) {
            self.editedItem.supervisor = self.supervisors[0].id;
          }
        }

        if (
          !_.find(self.supervisors, s => {
            return s.id == self.editedItem.supervisor;
          })
        ) {
          var missingMember = _.find(self.allMembers, s => {
            return s.id == self.editedItem.supervisor;
          });

          return [...self.supervisors, missingMember];
        } else {
          return self.supervisors;
        }
      }

      if (editMode) {
        var supervisors = calc(self);

        if (!supervisors) supervisors = [];

        //If role of any of the selected members is superadmin, then remove all non superadmins from the result
        var hasSuperAdmin = false;

        _.each(this.selected, selected => {
          if (selected.role.toLowerCase() == "superadmin") {
            hasSuperAdmin = true;
          }
        });

        if (hasSuperAdmin) {
          return _.filter(supervisors, s => {
            return s.role.toLowerCase() == "superadmin";
          });
        } else {
          try {
            return _.map(
              _.filter(supervisors, s => {
                return (
                  _.find(self.allMembers, m => {
                    return m.id == s.id;
                  }) != undefined
                );
              }),
              s => {
                s.displayName = `${s.firstName} ${s.lastName}(${s.email})`;
                return s;
              }
            );

            //return supervisors;
          } catch (e) {
            return [];
          }
        }
      } else {
        return calc(self);
      }
    },
    getAllLocations() {
      const self = this;
      this.$http
        .get(
          `${this.$store.state.endpoint}locations?filter[where][companyId]=${this.$store.state.userDetails.companyId}`
        )
        .then(response => {
          self.allLocations = response.body;
        })
        .catch(error => {});
    },
    getGroups() {
      const self = this;
      this.$http
        .get(
          `${this.$store.state.endpoint}groups?filter[where][companyId]=${this.$store.state.userDetails.companyId}`
        )
        .then(response => {
          self.groups = response.body;
        })
        .catch(error => {
          this.$swal({ type: "error", text: "Something went wrong" });
        });
    },

    getHolidaySet() {
      const self = this;
      this.$http
        .get(
          `${this.$store.state.endpoint}holidaysets?filter[where][companyId]=${this.$store.state.userDetails.companyId}`
        )
        .then(response => {
          self.allowedHolidaySets = response.body;
        })
        .catch(err => {
          self.$swal({ type: "error", text: "Sorry, try again later" });
        });
    },

    getWeeklyOffSet() {
      const self = this;
      this.$http
        .get(
          `${this.$store.state.endpoint}weeklyoffsets?filter[where][companyId]=${this.$store.state.userDetails.companyId}`
        )
        .then(response => {
          self.allowedWeeklyOffSets = response.body;
        })
        .catch(err => {
          self.$swal({ type: "error", text: "Sorry, try again later" });
        });
    },

    // BULK operations FOR SELECTED MEMBERS
    bulkMembersOperation(operation) {
      this.afterUpdate = true;
      this.loader = true;

      if (this.selectedMembersId.length < 1) {
        this.afterUpdate = false;
        this.loader = false;
        return this.$swal({ type: "warning", text: "Select members you want to modify" });
      }

      const self = this;
      let meta = {};

      switch (operation) {
        case "changeSupervisor":
          if (this.bulkSelectedAllowedSupervisor == "") {
            this.afterUpdate = false;
            this.loader = false;
            this.$swal({ type: "warning", text: "Field is empty" });
            return;
          } else {
            meta = { supervisor: this.bulkSelectedAllowedSupervisor };
          }
          break;
        case "changeAllowedLocation":
          if (this.bulkSelectedAllowedLocation == "") {
            this.afterUpdate = false;
            this.loader = false;
            this.$swal({ type: "warning", text: "Field is empty" });
            return;
          } else {
            meta = { allowedLocations: this.bulkSelectedAllowedLocation };
          }
          break;
        case "changeGroup":
          if (this.bulkSelectedAllowedGroup == "") {
            this.afterUpdate = false;
            this.loader = false;
            this.$swal({ type: "warning", text: "Field is empty" });
            return;
          } else {
            meta = { groupId: this.bulkSelectedAllowedGroup };
          }
          break;
        case "changeShifts":
          meta = { allowedShifts: this.bulkSelectedAllowedShift };

          break;
        case "changeForms":
          if (this.bulkSelectedAllowedForm == "") {
            this.afterUpdate = false;
            this.loader = false;
            this.$swal({ type: "warning", text: "Field is empty" });
            return;
          } else {
            meta = { allowedForms: this.bulkSelectedAllowedForm };
          }

          break;
        case "changeSecurity":
          meta = { securitySettings: this.bulkSelectedSecuritySettings };

          break;
        case "changeFieldTrackingSettings":
          meta = { fieldTrackingSettings: this.bulkSelectedFieldTrackingSettings };

          break;

        case "changeRealtimeFieldTrackingSettings":
          meta = { realtimeFieldTrackingSettings: this.bulkSelectedRealTimeFieldTracking };

          break;
      }

      this.$swal({
        text: "Are you sure you want to update these members?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "info",
        cancelButtonColor: "#d33",
        confirmButtonText: "Confirm"
      }).then(result => {
        if (result.value) {
          self.afterUpdate = true;
          self.$http
            .post(`${self.$store.state.endpoint}Accounts/bulk`, {
              ids: this.selectedMembersId,
              meta,
              operation
            })
            .then(
              response => {
                self.bulkSupervisorDialog = false;
                self.bulkGroupDialog = false;
                self.bulkShiftDialog = false;
                self.allowedLocationDialog = false;
                self.bulkFormDialog = false;
                self.bulkSettingDialog = false;
                self.bulkFieldTrackingSettingDialog = false;
                self.bulkRealTimeFieldTrackingDialog = false;
                self.updateTagAndLocation();
                self.loader = false;
                self.afterUpdate = false;
                self.$swal({
                  type: "success",
                  text: "Successfully updated"
                });
              },
              error => {
                self.loader = false;
                self.afterUpdate = false;
                self.$swal({ type: "error", text: "Sorry, try again later." });
              }
            );
        }
      });
      self.afterUpdate = false;
      self.loader = false;
    },

    getGroupName(groupId) {
      const groupName = _.join(
        _.without(
          _.map(this.groups, o => {
            if (_.includes(groupId, o.id)) {
              return o.name;
            }
          }),
          undefined
        ),
        ","
      );
      return groupName;
    },

    canSee(what, role, options) {
      return canSee(this, what, role, options);
    },

    handleClick: e => {
      // console.log(e);
    },

    generateSupervisors() {
      const self = this;

      //Resolving all memmbers of the company for my visibility

      if (this.$store.state.userDetails.role.toLowerCase() == "user") {
        try {
          self.supervisors = [self.members[0].supervisorDetails];
        } catch (e) {}
      } else {
        this.$http
          .post(`${this.$store.state.endpoint}Accounts/byFilter`, {
            groupId: "all",
            include: "supervisorDetails"
          })
          .then(response => {
            self.supervisors = [];
            var response = response.body;

            var supervisors;

            supervisors = _.filter(response, r => {
              return r.role.toLowerCase() != "user";
            });

            supervisors = [
              ...supervisors,
              ..._.map(response, r => {
                return r.supervisorDetails;
              })
            ];

            _.each(supervisors, m => {
              m.displayName = `${m.firstName} ${m.lastName} (${m.email})`;
            });

            supervisors = _.uniqBy(supervisors, "id");

            //If not in my group set unselectable
            if (self.$store.state.userDetails.role.toLowerCase() != "superadmin") {
              _.map(supervisors, m => {
                var found = false;

                _.each(m.groupId, i => {
                  if (self.$store.state.userDetails.groupId.includes(i)) found = true;
                });

                if (!found) {
                  m.disabled = true;
                }
                return m;
              });
            }

            self.supervisors = supervisors;
          });
      }

      const filter = encodeURIComponent(
        JSON.stringify({
          where: { companyId: this.$store.state.userDetails.companyId, role: { nlike: "User" } },
          fields: {
            firstName: true,
            lastName: true,
            id: true,
            email: true,
            role: true,
            groupId: true,
            tags: true
          }
        })
      );

      this.$http.get(`${this.$store.state.endpoint}Accounts?filter=${filter}`).then(response => {
        self.allMembers = [];
        var response = response.body;

        _.each(response, m => {
          m.displayName = `${m.firstName} ${m.lastName} (${m.email})`;
        });

        self.allMembers = response;
      });
    },

    autoDetectTimeZone() {
      this.defaultItem.tz.name = this.editedItem.tz.name = moment.tz.guess();
    },

    pickFile() {
      this.$refs.csv.click();
    },

    bulkAddDialogPopup() {
      this.bulkAddDialog = true;
      this.parse_header = [];
      this.parse_csv = [];
      this.sortOrders = {};
      this.sortKey = "";
      this.csvName = "";
    },

    getCompany() {
      this.$http
        .get(`${this.$store.state.endpoint}companies/${this.$store.state.userDetails.companyId}`)
        .then(
          response => {
            this.companyData = [];
            this.companyData = response.body;
          },
          error => {
            // error callback
            this.$swal({ type: "error", text: "Something went wrong" });
          }
        );
    },
    getPermissions() {
      this.$http.get(`${this.$store.state.endpoint}permissions`).then(
        response => {
          const permissions = [];
          const self = this;
          // Processing permissions
          _.each(response.body, p => {
            p.disabled = true;
            if (self.$store.state.userDetails.role == "SuperAdmin") {
              p.disabled = false;
            } else if (
              self.$store.state.userDetails.role == "Admin" &&
              _.includes(self.$store.state.userDetails.permissions, p.id)
            ) {
              p.disabled = false;
            }
            permissions.push(p);
          });

          this.permissions = permissions;
        },
        error => {
          // error callback
          this.$swal({
            type: "error",
            text: "Please try again later"
          });
        }
      );
    },

    csvJSON(csv) {
      const vm = this;
      const lines = csv.split("\n");
      const result = [];
      const headers = [
        "firstName",
        "lastName",
        "role",
        "phone",
        "email",
        "password",
        "supervisor",
        "isGeoseal",
        "isPhotoid",
        "isWifissid",
        "isFieldtracking"
      ];
      vm.parse_header = headers;
      lines[0].split(",").forEach(key => {
        vm.sortOrders[key] = 1;
      });

      lines.map((line, indexLine) => {
        if (indexLine < 1) return; // Jump header line

        const obj = {};
        const currentline = line.split(",");

        headers.map((header, indexHeader) => {
          try {
            obj[header] = currentline[indexHeader].replace(/[\n\r]+/g, "").trim();
          } catch (e) {}
        });

        result.push(obj);
      });

      result.pop(); // remove the last item because undefined values

      return result;
      // JavaScript object
    },
    loadCSV(e) {
      const vm = this;
      vm.parse_csv = [];
      vm.csvName = "";
      if (window.FileReader) {
        const reader = new FileReader();
        vm.csvName = e.target.files[0].name;
        reader.readAsText(e.target.files[0]);
        // Handle errors load
        reader.onload = function(event) {
          const csv = event.target.result;
          vm.parse_csv = vm.csvJSON(csv);

          e.target.value = null;
        };
        reader.onerror = function(evt) {
          if (evt.target.error.name == "NotReadableError") {
            alert("Canno't read file !");
          }
        };
      } else {
        alert("FileReader are not supported in this browser.");
      }
    },

    bulkMemberAdd() {
      const itemObj = this.editedItem;

      const self = this;
      function getSupervisorId(value) {
        const memberData = self.members;
        for (const o in memberData) {
          if (memberData[o].email == value) {
            return memberData[o].id;
          }
        }
      }

      function locationId(value) {
        const locationData = self.locations;
        for (const o in locationData) {
          if (locationData[o].code == value) {
            return locationData[o].id;
          }
        }
      }

      const data = this.parse_csv;

      const response = [];
      for (const n in data) {
        response.push(data[n]);
      }

      for (const m in response) {
        // response[m].groupId = groupId(response[m].groupId)
        response[m].supervisor = getSupervisorId(response[m].supervisor);

        response[m].securitySettings = {
          isGeoseal: response[m].isGeoseal == "TRUE",
          isPhotoid: response[m].isPhotoid == "TRUE",
          isWifissid: response[m].isWifissid == "TRUE"
        };
        response[m].fieldTrackingSettings = {
          enabled: response[m].isFieldtracking == "TRUE"
        };

        response[m].realtimeFieldTrackingSettings = {
          enabled: response[m].isRealtimeFieldTracking == "TRUE"
        };
        response[m].allowedLocations = [];
        response[m].allowedForms = [];
        response[m].allowedShifts = [];
        response[m].companyId = this.$store.state.userDetails.companyId;
        response[m].tz = {
          name: itemObj.tz.name,
          offset: moment()
            .tz(itemObj.tz.name)
            .utcOffset()
        };

        delete response[m].isFieldtracking;
        delete response[m].isGeoseal;
        delete response[m].isPhotoid;
        delete response[m].isWifissid;
        /*  if (response[m].supervisorL1 == response[m].supervisorL2){
            response.splice(m, 1);
          }

          */
      }

      const postObj = {
        data: response
      };

      this.$http.post(`${this.$store.state.endpoint}Accounts/bulk/create`, postObj).then(
        response => {
          this.bulkAddDialog = false;
          this.parse_header = [];
          this.parse_csv = [];
          this.sortOrders = {};
          this.sortKey = "";
          this.csvName = "";
          this.updateTagAndLocation();
        },
        error => {
          this.$swal({ type: "error", text: "Something went wrong" });
        }
      );
    },

    getForms() {
      this.$http
        .get(
          `${this.$store.state.endpoint}forms?filter[where][companyId]=${this.$store.state.userDetails.companyId}`
        )
        .then(
          response => {
            this.forms = [];
            this.forms = response.body;
          },
          error => {
            this.$swal({ type: "error", text: "Something went wrong" });
          }
        );
    },
    getTags() {
      this.$http
        .get(
          `${this.$store.state.endpoint}tags?filter[where][companyId]=${this.$store.state.userDetails.companyId}`
        )
        .then(
          response => {
            this.tags = [];
            this.tags = response.body;
          },
          error => {
            this.$swal({ type: "error", text: "Something went wrong" });
          }
        );
    },
    getShifts() {
      this.shifts = [];

      this.$http
        .get(
          `${this.$store.state.endpoint}shifts?filter[where][companyId]=${this.$store.state.userDetails.companyId}`
        )
        .then(response => {
          var response = response.body;
          if (response.length > 0) {
            this.editedItem.allowedShifts = [response[0].id];
            this.shifts = response;
          } else {
            this.editedItem.allowedShifts = [];
            this.shifts = response;
          }
        })
        .catch(error => {
          this.$swal({ type: "error", text: "Something went wrong" });
          this.loading.membersOption = false;
          this.networkError.membersOption = true;
        });
    },

    updateTagAndLocation(tags) {
      this.loading.membersOption = true;

      if (typeof tags !== "undefined" && tags.hasOwnProperty("locations")) this.selectedTags = tags;

      this.members = [];

      this.$http
        .post(`${this.$store.state.endpoint}Accounts/byFilter`, {
          tags: this.selectedTags.tags,
          locations: this.selectedTags.locations,
          groupId: this.selectedTags.group,
          mode: this.selectedTags.mode,
          include: "supervisorDetails"
        })
        .then(response => {
          var response = response.body;

          const self = this;

          function locationName(value) {
            const locationData = self.allLocations;
            for (const o in locationData) {
              if (locationData[o].id == value) {
                return locationData[o].name;
              }
            }
          }

          function WeeklyOffName(value) {
            for (const o in self.allowedWeeklyOffSets) {
              if (self.allowedWeeklyOffSets[o].id == value) {
                return self.allowedWeeklyOffSets[o].name;
              }
            }
          }

          function holidayName(value) {
            for (const o in self.allowedHolidaySets) {
              if (self.allowedHolidaySets[o].id == value) {
                return self.allowedHolidaySets[o].name;
              }
            }
          }

          function shiftName(value) {
            const shiftData = self.shifts;
            for (const o in shiftData) {
              if (shiftData[o].id == value) {
                return shiftData[o].name;
              }
            }
          }

          function taName(value) {
            const tagData = self.tags;
            for (const o in tagData) {
              if (tagData[o].id == value) {
                return tagData[o].name;
              }
            }
          }

          function formName(value) {
            const formData = self.forms;
            for (const o in formData) {
              if (formData[o].id == value) {
                return formData[o].name;
              }
            }
          }

          this.membersContents = [];

          for (const x in response) {
            if (response[x].allowedLocations.length > 1) {
              const { allowedLocations } = response[x];
              response[x].allowedLocationName = [];
              for (var m in allowedLocations) {
                response[x].allowedLocationName.push(locationName(allowedLocations[m]));
              }
            } else {
              response[x].allowedLocationName = locationName(response[x].allowedLocations);
            }

            if (response[x].allowedForms.length > 1) {
              const { allowedForms } = response[x];
              response[x].allowedFormName = [];
              for (var m in allowedForms) {
                response[x].allowedFormName.push(formName(allowedForms[m]));
              }
            } else {
              response[x].allowedFormName = formName(response[x].allowedForms);
            }

            if (response[x].allowedShifts.length > 1) {
              const { allowedShifts } = response[x];
              response[x].allowedShiftsName = [];
              for (var m in allowedShifts) {
                response[x].allowedShiftsName.push(shiftName(allowedShifts[m]));
              }
            } else {
              response[x].allowedShiftsName = shiftName(response[x].allowedShifts);
            }

            if (response[x].tags.length > 1) {
              const { tags } = response[x];
              response[x].tagsName = [];
              for (var m in tags) {
                response[x].tagsName.push(taName(tags[m]));
              }
            } else {
              response[x].tagsName = taName(response[x].tags);
            }

            let locationsName = response[x].allowedLocationName;
            let formsName = response[x].allowedFormName;
            let shiftsName = response[x].allowedShiftsName;
            let tagName = response[x].tagsName;

            if (locationsName == undefined) {
              locationsName = "";
            }
            if (formsName == undefined) {
              formsName = "";
            }
            if (shiftsName == undefined) {
              shiftsName = "";
            }
            if (tagName == undefined) {
              tagName = "";
            }

            response[x].allowedShiftsName = shiftsName.toString();
            response[x].allowedFormName = formsName.toString();
            response[x].allowedLocationName = locationsName.toString();
            response[x].tagsName = tagName.toString();
            response[x].fullName = `${response[x].firstName}` + " " + `${response[x].lastName}`;

            if (typeof response[x].supervisorDetails !== "undefined") {
              response[
                x
              ].supervisorName = `${response[x].supervisorDetails.firstName} ${response[x].supervisorDetails.lastName}`;
            }

            if (typeof response[x].supervisorDetails !== "undefined") {
              response[x].supervisorEmail =
                response[x].supervisorDetails.email + " (" + response[x].supervisorName + ")";
            }

            response[x].inGroupName = self.getGroupName(response[x].groupId);

            if (response[x].allowedWeeklyOffSets.length > 0) {
              var { allowedWeeklyOffSets } = response[x];
              response[x].allowedWeeklyOffName = [];

              for (var m in allowedWeeklyOffSets) {
                response[x].allowedWeeklyOffName.push(WeeklyOffName(allowedWeeklyOffSets[m]));
              }
            } else {
              response[x].allowedWeeklyOffName = [];
            }

            if (response[x].allowedHolidaySets.length > 0) {
              var { allowedHolidaySets } = response[x];
              response[x].allowedHolidayName = [];
              for (var m in allowedHolidaySets) {
                response[x].allowedHolidayName.push(holidayName(allowedHolidaySets[m]));
              }
            } else {
              response[x].allowedHolidayName = [];
            }

            response[x].contents = {
              Email: response[x].email,
              Role: response[x].role,
              Shifts: response[x].allowedShiftsName,
              Location: response[x].allowedLocationName,
              Groups: response[x].inGroupName,
              Supervisor: response[x].supervisorEmail,
              Tag: response[x].tagsName
            };

            response[x].title = response[x].firstName + " " + response[x].lastName;
            response[x].visible = true;

            this.membersContents.push(response[x]);
          }

          this.membersContents.sort((a, b) =>
            a.title.localeCompare(b.title, "es", { sensitivity: "base" })
          );

          this.members = this.membersContents;

          if (this.$store.state.userDetails.role.toLowerCase() == "user") {
            this.generateSupervisors();
          }

          this.loader = false;

          this.loading.membersOption = false;
          this.networkError.membersOption = false;

          // this.setLoading = false
        })
        .catch(error => {
          this.loader = false;

          this.loading.membersOption = false;
          this.networkError.membersOption = true;
        });
    },
    openAddWindow() {
      this.editedIndex = -1;
      this.editedItem = Object.assign({}, this.defaultItem);
      // this.$refs.First.resetValidation();
      // this.$refs.Email.resetValidation();
      // this.$refs.Time.resetValidation();
      this.dialog = true;
    },
    editItem(item) {
      this.editedIndex = this.members.indexOf(item);

      // this.defaultItem.role = item.role;
      this.editItem.allowedLocations = [];
      this.matchDevice = item.securitySettings.matchDevice;
      this.editedItem = Object.assign({}, item);

      this.dialog = true;
    },

    // delete members
    deleteItem(item) {
      const self = this;
      self.loader = true;
      this.$swal({
        title: `Delete ${item.firstName}?`,
        text: "Note: All the records will be deleted from Regular.li. Backup should be taken",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "info",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes"
      }).then(result => {
        if (result.value) {
          this.loader = true;
          const itemObj = item.id;
          const index = this.members.indexOf(item);

          // write item delete code
          this.$http.delete(`${this.$store.state.endpoint}Accounts/${itemObj}/delete`).then(
            response => {
              if (itemObj == self.$store.state.userDetails.id) {
                firebase
                  .auth()
                  .signOut()
                  .then(() => {
                    window.localStorage.clear();
                    self.$router.go({ path: self.$router.path });
                  });
                window.localStorage.clear();
              } else {
                self.generateSupervisors();
                self.updateTagAndLocation();
                fb.log("member_delete");
              }
            },
            error => {
              self.loader = false;
              self.afterUpdate = false;
              this.$swal({ type: "error", text: error.body.error.message });
            }
          );
        }
      });
      self.loader = false;
    },

    // reset device for selected users
    async batchResetDevice() {
      // block if user is not superadmin
      if (this.$store.getters.userDetails.role != "SuperAdmin") {
        this.$swal({
          type: "warning",
          text: "Admins and Users are not allowed to perform this action"
        });
        return;
      }
      // empty selected users
      if (this.selectedMembersId.length < 1) {
        this.$swal({ type: "warning", text: "There is no selected members" });
        return;
      }

      this.loader = true;

      // for (var x in this.selectedMembersId) {
      //
      //     await this.$http.post(
      //       `${this.$store.state.endpoint}Accounts/${this.selectedMembersId[x]}/resetdevice`
      //     );
      //
      // }

      try {
        await this.$http.post(`${this.$store.state.endpoint}Accounts/batchreset`, {
          ids: this.selectedMembersId
        });
      } catch (e) {
        this.loader = false;

        return this.$swal({
          type: "error",
          text: "Something went wrong while resetting devices"
        });
      }

      this.$swal({
        type: "success",
        text: "Devices restored"
      });
      this.loader = false;
      this.updateTagAndLocation(this.$store.getters.getSelectedTagsAndLocations);
    },

    // ids recieved from the component
    BulkDeleteIds(ids) {
      this.selectedMembersId = ids;
    },

    // Bulk Delete operation
    bulkDeleteMembers() {
      // block if user is not superadmin
      if (this.$store.state.userDetails.role != "SuperAdmin") {
        this.$swal({
          type: "warning",
          text: "Admins and Users are not allowed to perform this action"
        });
        return;
      }
      // empty selected users
      if (this.selectedMembersId.length < 1) {
        this.$swal({ type: "warning", text: "There is no selected members" });
        return;
      }

      this.$swal({
        title: "Are you sure?",
        text: "Note: All the records will be deleted from Regular.li. Backup should be taken",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "info",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes"
      }).then(result => {
        if (result.value) {
          this.loader = true;
          const postObj = {
            ids: this.selectedMembersId
          };

          this.$http.post(`${this.$store.state.endpoint}Accounts/bulk/delete`, postObj).then(
            response => {
              this.selectedMembersId = [];
              this.updateTagAndLocation();
              this.bulkdeleteDisabled = false;
              this.selectAllData = false;
              this.loader = false;
              if (response.body.length > 0) {
                this.$swal({ type: "success", text: "Successfully deleted with some errors" });
              } else {
                this.$swal({ type: "success", text: "Successfully deleted" });
              }
            },
            error => {
              this.bulkdeleteDisabled = false;
              this.loader = false;
              this.$swal({ type: "error", text: error.body.error.message });
            }
          );
        }
      });
      this.loader = false;
    },

    signOut() {
      try {
        this.$http
          .post(`${this.$store.state.endpoint}Accounts/logout`)
          .then(res => {
            firebase
              .auth()
              .signOut()
              .then(() => {
                window.localStorage.clear();
                this.$router.go({ path: this.$router.path });
              })
              .catch(err => {
                window.localStorage.clear();
                this.$router.go({ path: this.$router.path });
              });
          })
          .catch(err => {
            window.localStorage.clear();
            this.$router.go({ path: this.$router.path });
          });

        //
      } catch (e) {
        window.localStorage.clear();
        this.$router.go({ path: this.$router.path });
      }
    },

    close() {
      // this.dialog = false
      setTimeout(() => {
        this.showGeoseal = false;
        this.showHotspot = false;
        this.showPhotoId = false;
        this.showWifi = false;
        this.showField = false;
        this.showFieldPhoto = false;
        this.showRealField = false;
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.$refs.First.resetValidation();
        this.$refs.Email.resetValidation();
        this.$refs.Time.resetValidation();
      }, 300);
      this.dialog = false;
    },

    save() {
      this.loader = true;
      const itemObj = this.editedItem;
      const self = this;

      if (itemObj.tz.name) {
        itemObj.tz = {
          name: itemObj.tz.name,
          offset: moment()
            .tz(itemObj.tz.name)
            .utcOffset()
        };

        delete itemObj.timezone;
      }

      if (this.editedIndex > -1) {
        console.log("Updating contact");
        if (this.editedItem.groupId == "") {
          this.loader = false;
          this.$swal({ type: "error", text: "Assign a group" });
          return;
        }

        if (this.editedItem.allowedLocations == "") {
          this.loader = false;
          this.$swal({ type: "error", text: "Please select a location" });
          return;
        }

        if (itemObj.code == "" || typeof itemObj.code == "undefined") {
          itemObj.code = itemObj.firstName.substring(0, 2) + Math.floor(Math.random() * 10000 + 1);
        } else {
          itemObj.code = itemObj.code;
        }

        if (itemObj.tz == "" || typeof itemObj.tz == "undefined") {
          this.loader = false;
          this.$swal({ type: "error", text: "Please select a timezone" });
          return;
        }

        const updateObj = {
          groupId: itemObj.groupId,
          companyId: itemObj.companyId,
          email: itemObj.email,
          firstName: itemObj.firstName,
          supervisor: itemObj.supervisor,
          code: itemObj.code,
          tz: itemObj.tz,
          securitySettings: {
            isGeoseal: itemObj.securitySettings.isGeoseal,
            isPhotoid: itemObj.securitySettings.isPhotoid,
            isWifissid: itemObj.securitySettings.isWifissid,
            matchDevice: itemObj.securitySettings.matchDevice,
            detectHotspot: itemObj.securitySettings.detectHotspot,
            isHuddle: itemObj.securitySettings.isHuddle
          },
          fieldTrackingSettings: {
            enabled: itemObj.fieldTrackingSettings.enabled,
            isPhotoid: itemObj.fieldTrackingSettings.isPhotoid,
            formId: itemObj.fieldTrackingSettings.formId
          },
          realtimeFieldTrackingSettings: {
            enabled: itemObj.realtimeFieldTrackingSettings.enabled,
            autoStart: itemObj.realtimeFieldTrackingSettings.autoStart
          },
          activityTrackings: {
            enabled: itemObj.activityTrackings.enabled,
            trackingDeviceId: itemObj.activityTrackings.trackingDeviceId
          },
          lastName: itemObj.lastName,
          phone: itemObj.phone,
          role: itemObj.role,
          allowedLocations: itemObj.allowedLocations,
          allowedShifts: itemObj.allowedShifts,
          allowedForms: itemObj.allowedForms,
          tags: itemObj.tags,
          permissions: itemObj.permissions,
          allowedHolidaySets: itemObj.allowedHolidaySets,
          allowedWeeklyOffSets: itemObj.allowedWeeklyOffSets
        };

        this.afterUpdate = true;

        this.$http
          .patch(`${this.$store.state.endpoint}Accounts/${itemObj.id}`, updateObj)
          .then(response => {
            // success callback
            console.log(response);
            if (self.$store.state.userDetails.id == response.body.id) {
              self.$store.dispatch("getUserData", { userId: self.$store.state.userDetails.id });
            }

            self.dialog = false;
            self.membersSorting();
            self.generateSupervisors();
            self.afterUpdate = false;
            self.$swal({
              type: "success",
              text: "Successfully updated"
            });
            self.updateTagAndLocation();
            // this.$refs.userFilter.calculateFilters();
            fb.log("member_update");
            EventBus.$emit("updateMemberCount");
          })
          .catch(err => {
            // error callback
            self.afterUpdate = false;
            self.loader = false;
            self.$swal({
              type: "error",
              text: "Something went wrong"
            });
          });
      } else {
        if (
          this.editedItem.firstName == "" ||
          this.editedItem.email == "" ||
          this.editedItem.allowedLocations == "" ||
          this.editedItem.supervisor == "" ||
          this.editedItem.groupId == ""
        ) {
          this.loader = false;
          this.$swal({
            type: "error",
            text: "Please fill the required fields"
          });
          return;
        }

        if (typeof this.$refs.passwordRules != "undefined") {
          if (this.$refs.passwordRules.validate() == false) {
            this.loader = false;
            this.$swal({
              type: "error",
              text: "Please fill the password fields correctly."
            });
            return;
          }
        }

        console.log("Creating contact 2");

        if (
          this.$refs.First.validate() == false ||
          this.$refs.Email.validate() == false ||
          this.$refs.Time.validate() == false
        ) {
          this.loader = false;
          this.$swal({
            type: "error",
            text: "Please fill the required fields correctly."
          });
          return;
        }

        console.log("Creating contact 3");
        if (this.editedItem.groupId == "") {
          this.loader = false;
          this.$swal({ type: "error", text: "Assign a group" });
          return;
        }

        if (itemObj.code == "" || typeof itemObj.code == "undefined") {
          itemObj.code = itemObj.firstName.substring(0, 2) + Math.floor(Math.random() * 10000 + 1);
        } else {
          itemObj.code = itemObj.code;
        }

        if (itemObj.password == "") {
          delete itemObj.password;
        }

        // activity tracking
        if (itemObj.activityTrackings.enabled && itemObj.activityTrackings.trackingDeviceId == "") {
          return this.$swal({ type: "warning", text: "Activity tracking device id missing" });
        }

        this.afterUpdate = true;
        this.$http
          .post(`${this.$store.state.endpoint}Accounts`, itemObj)
          .then(response => {
            EventBus.$emit("updateMemberCount");

            this.dialog = false;
            this.generateSupervisors();
            // this.$refs.userFilter.calculateFilters();
            // reset validations
            this.$refs.First.resetValidation();
            this.$refs.Email.resetValidation();
            this.$refs.Time.resetValidation();
            self.membersSorting();
            this.$swal({
              type: "success",
              text: "Successful"
            });

            this.afterUpdate = false;
            this.updateTagAndLocation();
            fb.log("member_add");
          })
          .catch(err => {
            // error callback
            this.afterUpdate = false;
            this.loader = false;
            this.$swal({
              type: "error",
              text: "Email is already in use"
            });
          });
      }
      this.close();
    },

    // open reset password window
    openResetWindow() {
      this.resetWindow = true;
    },
    // set password for members
    resetPassword() {
      this.loader = true;
      this.afterUpdate = true;
      // validate
      if (this.newPassword == "") {
        this.loader = false;
        this.afterUpdate = false;
        return this.$swal({ type: "warning", text: "Field cannot be empty" });
      }

      this.$http
        .put(`${this.$store.state.endpoint}accounts/${this.editedItem.id}/updatePassword`, {
          email: this.editedItem.email,
          newPassword: this.newPassword
        })
        .then(response => {
          if (response.body.user.id == this.$store.getters.userDetails.id) {
            return this.signOut();
          }
          this.$swal({ type: "success", text: "Successful" });
          this.resetWindow = false;
          this.dialog = false;
          this.newPassword = "";
          this.loader = false;
          this.afterUpdate = false;
          this.updateTagAndLocation();
        })
        .catch(err => {
          this.$swal({ type: "error", text: err.body.error.message });
          this.resetWindow = true;
          this.dialog = true;
          this.loader = false;
          this.afterUpdate = false;
        });
    }
  }
};
</script>

<style scoped>
.listHeightFix .v-list__tile__title {
  height: 40px;
}
.menu-icon {
  margin-left: 7px;
}
.menu-title {
  font-size: 14px !important;
  color: #706f6f;
}
.menu-sub-icon {
  margin-left: 25px;
}
.menu-sub-title {
  font-size: 14px !important;
  margin-left: 15px;
}
.gps-btn {
  /* margin-left: 327px;
    z-index: 1;
    top: -35px; */
  margin-left: -100px;
  background: transparent !important;
  box-shadow: none !important;
}
.gps-btn:hover {
  background-color: none !important;
}
.gps-field {
  margin-bottom: -45px;
}
.headline {
  margin-top: 10px;
  margin-left: 10px;
  letter-spacing: 2px !important;
  font-size: 23px !important;
}

/* bulk btn */
.bulk_btn {
  font-size: 13px;
  text-transform: none;
  font-weight: 100 !important;
  margin-left: -15px;
  color: #706f6f;
}
.v-card {
  margin-bottom: 2px !important;
}
</style>
